import React from 'react';

export const Beach = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M32.5043 16.4436L30.4004 15.167L21.8494 29.2592L23.9533 30.5358L32.5043 16.4436Z"
      fill="url(#paint0_linear_378174_8496)"
    />
    <path
      d="M11.8079 39.7602L18.4848 43L23.5758 39.7602L30.9104 42.4324L34.7233 38.9502L37 40.5225L38 39.9679C37.9261 35.8089 35.3906 31.7779 30.9104 29.5811C24.1901 26.2752 15.6235 28.3227 11.8079 34.1453C10.4786 36.1715 9.91243 38.3683 10.0109 40.5225L11.8079 39.7602Z"
      fill="url(#paint1_linear_378174_8496)"
    />
    <path
      d="M35.8306 35.728C35.1633 35.728 34.6007 36.1773 34.3967 36.8239L34.3964 36.8249C33.63 39.2922 31.754 40.486 29.8999 40.5077C28.0436 40.5294 26.1717 39.3774 25.4081 37.0578C25.2028 36.438 24.6399 35.9912 23.9751 35.9912C23.3045 35.9912 22.7705 36.4435 22.5672 37.0573L22.5667 37.0589C21.8151 39.3781 19.9492 40.5365 18.0926 40.5241C16.2381 40.5117 14.3566 39.3302 13.5784 36.8764C13.3727 36.2245 12.7797 35.7778 12.0889 35.807C11.4032 35.8101 10.8533 36.3608 10.6827 36.9917L10.6804 37.001C10.2692 38.79 9.50541 39.7284 8.64908 40.2663L8.64738 40.2674C7.7575 40.8365 6.56671 41.0703 5.24275 41.0965C4.39265 41.0979 3.75 41.831 3.75 42.6622C3.75 43.4977 4.42199 44.228 5.24533 44.228C6.8661 44.228 8.66219 43.9342 10.2111 42.9523C11.0257 42.4359 11.7336 41.7437 12.3163 40.8597C15.3927 44.6177 21.0219 44.5893 24.0005 40.7641C27.0366 44.6448 32.8204 44.5649 35.8302 40.5891C37.5094 42.8235 40.1401 44.1228 42.7547 44.1228C43.6061 44.1228 44.25 43.3891 44.25 42.557C44.25 41.7215 43.578 40.9912 42.7547 40.9912C40.3986 40.9912 38.0545 39.3784 37.265 36.8252L37.2646 36.8239C37.0606 36.1773 36.498 35.728 35.8306 35.728Z"
      fill="url(#paint2_linear_378174_8496)"
    />
    <path
      d="M39.4293 26.1048C40.2012 26.5762 41.2052 26.3817 41.7452 25.6561L42.2499 24.978C45.75 18.4777 44.1079 10.225 37.4999 6.1781C30.8919 2.13116 22.2242 3.86422 18.2047 10.4464L17.9195 10.909C17.4105 11.7342 17.6694 12.8158 18.4968 13.3212L39.4293 26.1048Z"
      fill="url(#paint3_linear_378174_8496)"
    />
    <path
      d="M37.4172 6.22607C34.3048 7.13092 28.2159 11.1417 24.7058 17.2151L33.4784 22.5621C37.2666 16.6583 38.0399 9.40694 37.4172 6.22607Z"
      fill="url(#paint4_linear_378174_8496)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_378174_8496"
        x1="24.0023"
        y1="26.7542"
        x2="35.2887"
        y2="15.653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CD3E1D" />
        <stop offset="1" stopColor="#592A00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_378174_8496"
        x1="24"
        y1="38.7993"
        x2="24"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC7A3" />
        <stop offset="1" stopColor="#FFA43D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_378174_8496"
        x1="24.0253"
        y1="42.647"
        x2="24.0253"
        y2="35.992"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0606792" stopColor="#0FAFFF" />
        <stop offset="1" stopColor="#0078D4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_378174_8496"
        x1="40.848"
        y1="30.7925"
        x2="21.7483"
        y2="3.54822"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA1D2D" />
        <stop offset="1" stopColor="#FB6F7B" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_378174_8496"
        x1="36.8292"
        y1="16.215"
        x2="25.8911"
        y2="12.1771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECBE6" />
        <stop offset="1" stopColor="#FDAFD9" />
      </linearGradient>
    </defs>
  </svg>
);
